import React, { useMemo, useState } from "react";
import { Button } from "devextreme-react";
import { Form, Item, Label } from "devextreme-react/form";
import { useDataSource } from "../../../contexts/dataSource";
import { getSelectBoxPropertiesIdName, getPropsDateEdit } from "../../../utils/default-props";

interface CustomAddFormProps {
    employeeId: number;
    onSuccess?: () => void;
}

interface FormData {
    earnedDate: Date | null;
    expiryDate: Date | null;
    deserved: number;
    used: number;
    remaining: number;
    leaveInfoId: number | null;
}

const CustomAddForm: React.FC<CustomAddFormProps & { onSuccess: () => void }> = ({ employeeId, onSuccess }) => {
    const { dataSourceHR } = useDataSource();
    const [formData, setFormData] = useState<FormData>({
        earnedDate: null,
        expiryDate: null,
        deserved: 0,
        used: 0,
        remaining: 0,
        leaveInfoId: null,
    });

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeLeaveAccrual/Employee/${employeeId}`,
        insertUrl: "/api/EmployeeLeaveAccrual/FormData",
    }), [dataSourceHR, employeeId]);

    const dbLeaveType = dataSourceHR({
        loadUrl: "/api/LeaveInfo",
        loadMode: "raw",
    });

    const leaveInfoEditorOptions = {
        ...getSelectBoxPropertiesIdName,
        dataSource: dbLeaveType,
        validationMessageMode: "always",
    };

    const handleSubmit = async () => {
        if (!formData.leaveInfoId || !formData.earnedDate || !formData.expiryDate) {
            return;
        }

        const newData = { ...formData, employeeId };

        try {
            await dataSource.insert(newData);

            setFormData({
                earnedDate: null,
                expiryDate: null,
                deserved: 0,
                used: 0,
                remaining: 0,
                leaveInfoId: null,
            });
            onSuccess?.();
        } catch (error) {
            console.error("Error adding new data:", error);
        }
    };

    return (
        <React.Fragment>
            <Form
                formData={formData}
                onFieldDataChanged={({ dataField, value }: any) => {
                    setFormData(prev => ({ ...prev, [dataField]: value }));
                }}
            >
                <Item
                    dataField="leaveInfoId"
                    editorType="dxSelectBox"
                    editorOptions={leaveInfoEditorOptions}
                    isRequired={true}
                >
                    <Label text="İzin Türü" />
                </Item>
                <Item
                    dataField="earnedDate"
                    editorType="dxDateBox"
                    editorOptions={getPropsDateEdit.editorOptions}
                    isRequired={true}
                >
                    <Label text="Hak Ediş Tarihi" />
                </Item>
                <Item
                    dataField="expiryDate"
                    editorType="dxDateBox"
                    editorOptions={getPropsDateEdit.editorOptions}
                    isRequired={true}
                >
                    <Label text="Bitiş Tarihi" />
                </Item>
                <Item
                    dataField="deserved"
                    editorType="dxNumberBox"
                    editorOptions={{ min: 0, showSpinButtons: true }}
                >
                    <Label text="Hak Edilen" />
                </Item>
                <Item
                    dataField="used"
                    editorType="dxNumberBox"
                    editorOptions={{ min: 0, disabled: true }}
                >
                    <Label text="Kullanılan" />
                </Item>
                <Item
                    dataField="remaining"
                    editorType="dxNumberBox"
                    editorOptions={{ min: 0, disabled: true }}
                >
                    <Label text="Kalan" />
                </Item>
                <Item>
                    <Button text="Kaydet" type="success" onClick={handleSubmit} />
                </Item>
            </Form>
        </React.Fragment>
    );
};

export default CustomAddForm;